<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true" :fullScreen="true">
    <div class="row">
        <div class="tab-content-oc">
            <div class="px-4">
                <div class="row d-flex">
                    <div class="col-xl-2 col-lg-4 col-md-6 px-3 py-2 me-5">
                        <label for="monedaInput" class="form-label fw-semibold">Moneda</label>
                        <div class="d-flex align-items-center">
                            <div class="form-check form-check-inline me-2">
                                <input class="form-check-input" type="radio" v-model="money.name" value="SOLES" @change="updateMoney()">
                                <label class="form-check-label" for="inlineRadio1">SOLES</label>
                            </div>
                            <div class="form-check form-check-inline me-2">
                                <input class="form-check-input" type="radio" v-model="money.name" value="DOLARES" @change="updateMoney()">
                                <label class="form-check-label" for="inlineRadio2">DOLARES</label>
                            </div>
                            <input type="number" v-model="money.type" :disabled="money.name === 'SOLES'" placeholder="Moneda" 
                            class="form-control form-control-sm ms-2 custom-width" step="0.1" @input="validateInput('type')" />
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-4 col-md-6 px-3 py-2">
                        <label for="monedaInput" class="form-label fw-semibold">Costo de Envio</label>
                        <div class="d-flex align-items-center">
                            <span class="me-1">{{ money.name !== 'SOLES' ? '$' : 'S/' }}</span>
                            <input  v-model="money.envio" @input="validateAmountCostSend" class="form-control form-control-sm custom-width" placeholder="C. de Envio"/>
                        </div>
                    </div>
                </div>


                <div class="col-md-12 table-responsive mt-3" id="div-tabla-anular">
                    <table id="tb-anular" class="table table-bordered text-center" aria-describedby="mydesc">
                        <thead class="bg-main" style="font-size: 12px">
                            <tr class="text-white text-center" style="vertical-align: middle">
                                <th scope="col">N°</th>
                                <th scope="col">IGV/ SIN IGV</th>
                                <th scope="col">NOMBRE</th>
                                <th scope="col" class="table-th-row" style="white-space: nowrap;"> <span class="me-5 ms-5">&nbsp;</span>MARCA<span class="me-5 ms-5">&nbsp;</span></th>
                                <th scope="col" colspan="1">CANTIDAD ENTRANTE</th>
                                <th scope="col" colspan="1"  style="white-space: nowrap;">PRECIO</th>
                                <th scope="col" colspan="1">SUBTOTAL</th>
                   <!--              <th scope="col" colspan="1" class="table-th-row" style="white-space: nowrap;">F. ADQUISICIÓN</th> -->
                                <th scope="col">ACCIÓN</th>
                            </tr>
                        </thead>

                        <tbody class="border-main" style="font-size: 12px; vertical-align: middle">
                            <tr v-if="datos.length === 0">
                                <td colspan="9">Sin registros</td>
                            </tr>
                            <template v-else>
                                <tr class="tbody-table1 text-center" v-for="(item, index) in datos" :key="index" :class="getRowClass(item)">
                                    <td>
                                        {{ index + 1}}
                                    </td>
                                    <td>
                                        <div class="form-check form-switch">
                                            <input v-model="item.igv" class="form-check-input"  @change="mtdIgvChange(index)"  type="checkbox" />
                                            {{ item.igv_num == 1 ? "CON IGV" : "SIN IGV" }}
                                        </div>
                                    </td>
                                    <td>
                                        {{ item.name }}
                                    </td>
                                    <td v-if="item.brands.length == 0">
                                        <div class="d-flex justify-content-center">
                                            <input v-model="item.newBrand" type="text" class="form-control form-control-sm input-cantidad align-middle" placeholder="Marca"/>
                                        </div>
                                    </td>
                                    <td v-else>
                                       <div class="text-center d-flex justify-content-center">
                                        <button
                                            class="btn btn-sm text-white bg-main me-2" style="font-size: 8px" @click="mtdAddBrand(item.id)">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                        <input 
                                            type="text" 
                                            class="form-control form-control-sm input-cantidad align-middle me-1"
                                            placeholder="Buscar"
                                            v-model="item.searchBrand"
                                            @keyup.enter="mtdopenmodal(item, index)"
                                        />
                                        <input 
                                            type="text" 
                                            class="form-control form-control-sm input-cantidad align-middle"
                                            placeholder="Marca"
                                            v-model="item.newBrand"
                                            disabled
                                        />
                                        </div>
                                    </td>
                                    <!--Cantidad-->
                                    <td>
                                        <div v-if="posEditQuantity !== index" @dblclick="mtdEditField(index, 'quantity')">
                                            {{ item.quantity }}
                                        </div>
                                        <div v-else>
                                            <input type="text" v-model="item.editQuantity" 
                                                    @keyup.enter="mtdSaveEdit(index, 'quantity')" 
                                                    @blur="mtdSaveEdit(index, 'quantity')" 
                                                    @keydown="filterKeyDni"
                                                    class="form-control form-control-sm text-center" 
                                                    placeholder="Cantidad" />
                                        </div>
                                    </td>
                                    <!--Fin Cantidad-->
                                    <!--Precio-->
                                    <td>
                                        <div v-if="posEditPrice !== index" @dblclick="mtdEditField(index, 'price')">
                                            {{ item.price}}
                                        </div>
                                        <div v-else>
                                            <input type="text" v-model="item.editPrice" 
                                                @keyup.enter="mtdSaveEdit(index, 'price')" 
                                                @blur="mtdSaveEdit(index, 'price')" 
                                                @keypress="isNumber($event)" 
                                                class="form-control form-control-sm text-center" 
                                                placeholder="Precio" />
                                        </div>
                                    </td>
                                    <!--Fin Precio-->
                                    <td>
                                        {{ (item.price ? (item.quantity * item.price).toFixed(3) : '0.00') }}
                                    </td>
<!--                                     <td>
                                        <div class="d-flex justify-content-center">
                                            <input v-model="item.fAdquisicion" type="date" class="form-control form-control-sm input-cantidad align-middle" :min="minDate" placeholder="F. Adquisicion" />
                                        </div>
                                    </td> -->
                                    <td>
                                        <a class="btn btn-primary btn-sm rounded-circle" type="button" style="background-color: #900052; border: 2px solid #900052;"
                                            @click="mtdDelete(item.id)">
                                            <i class="fas fa-trash-alt"></i>
                                        </a>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
               <div class="row mx-0 mt-3">
                 <div class="row mx-0 px-0 col-xl-9 col-lg-8 col-md-12 col-sm-12 d-flex mt-2">
                     <div class="col-sm-12 my-1">
                        <div id="div-story" class="form-group row align-left">
                            <label for="story" class="col-sm-12 col-md-12 color-main fw-bold">COMENTARIO</label>
                            <div class="col-xl-6 col-sm-12 col-md-8 mt-2">
                                <textarea rows="3" v-model="observation" placeholder="Comentario" class="form-control text-xs" aria-label="With textarea" id="story"></textarea>
                            </div>
                        </div>
                    </div>
                 </div>
                 <div class="px-0 col-xl-3 col-lg-4 col-md-12 col-sm-12 ">
                    <div class="d-flex flex-column align-items-end">
                        <div class="px-2 py-1 bg-white">
                            <span class="fw-semibold">VALOR VENTA :</span> <span style="padding-left: 20px;">{{ money.name !== 'SOLES' ? '$' : 'S/' }} {{ mtdValor() }}</span>
                        </div>
                        <div class="px-2 py-1 bg-white">
                            <span class="fw-semibold">IGV :</span> <span style="padding-left: 20px;">{{ money.name !== 'SOLES' ? '$' : 'S/' }} {{ mtdGetIgv() }}</span>
                        </div>
                        <div class="px-2 py-1 bg-white">
                            <span class="fw-semibold">SUB TOTAL C/ IGV :</span> <span style="padding-left: 20px;">{{ money.name !== 'SOLES' ? '$' : 'S/' }} {{ mtdGetSubTotal() }}</span>
                        </div>
                        <div class="px-2 py-1 bg-white">
                            <span class="fw-semibold">COSTO DE ENVIO :</span> <span style="padding-left: 20px;">{{ money.name !== 'SOLES' ? '$' : 'S/' }} {{ money.envio ? money.envio : 0}}</span>
                        </div>
                        <div class="px-2 py-1 bg-white">
                            <span class="fw-semibold">TOTAL C/ IGV :</span> <span style="padding-left: 20px;">{{ money.name !== 'SOLES' ? '$' : 'S/' }} {{ mtdGetTotal() }}</span>
                        </div>
                    </div>
                 </div>
               </div>
            </div>
        </div>
    </div>


    <template #footer>
        <button type="button" class="btn btn-register text-white" :disabled="isSaveDisabled" @click="registerCarrito">
           ENVIAR
        </button>
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import CButtonClose from "@/components/shared/modals/cButtonClose.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {mapActions} from "vuex";
import moment from "moment";

export default {
    name: "c-modal-notaIngreso",
    components: {
        SweetAlert,
        CModal,
        CButtonClose,
    },
    created() {
    },
    data() {
        return {
            swal: null,
            money: {
                name: 'SOLES',
                type: 1,
                valor: 0,
                envio: 0,
            },
            observation: '',
            posEditConcentration: null,
            posEditQuantity: null,
            posEditPrice: null,
            tempPrice: '',
            minDate: moment().format('YYYY-MM-DD'),
        };
    },
    props: {
        title: String,
        boo_modal: Boolean,
        datos: [],
        valorType: {
          type: Number,
          default: 0
        },
        valorTypeVen: {
          type: Number,
          default: 0
        }
    },
    watch: {   
    },
    computed: {
        isSaveDisabled() {
            if (this.datos.length === 0) {
                return true;
            }

            return this.datos.some(item => {
                return (
                    !item.quantity || parseFloat(item.quantity) <= 0 ||
                    !item.price || parseFloat(item.price) <= 0 ||
                    !item.newBrand || item.newBrand.trim() == ''
                );
            });
        }
    },
    methods: {
        ...mapActions(["get", "post"]),

        getRowClass(item) {
            if (
                item.quantity && parseFloat(item.quantity) > 0 &&
                item.price && parseFloat(item.price) > 0 &&
                item.newBrand && item.newBrand.trim() !== '') {
                return 'bg-light-green';
            }
            return '';
        },

        mtdclosemodal() {
            this.money.name = 'SOLES';
            this.money.type = 1;
            this.$emit("closeModalCarrito");
        },

        mtdDelete: function (item) {
            this.$emit("mtdDelete", item);
        },

        mtdEditField(index, field) {
            this.resetEditFields();
            if (field === "quantity") {
                this.posEditQuantity = index;
                this.datos[index].editQuantity = this.datos[index].quantity;
            } else if (field === "price") {
                this.posEditPrice = index;
                this.datos[index].editPrice = this.datos[index].price;
            }
            this.editingField = field;
        },

        mtdSaveEdit(index, field) {
            if (field === "quantity") {
                const newQuantity = parseInt(this.datos[index].editQuantity);
                if (!isNaN(newQuantity)) {
                    this.datos[index].quantity = newQuantity;
                }
            } else if (field === "price") {
                const newPrice = parseFloat(this.datos[index].editPrice);
                if (!isNaN(newPrice)) {
                    this.datos[index].price = newPrice.toFixed(3);
                    //this.datos[index].price = parseFloat(newPrice.toFixed(3));
                }
            }
            this.resetEditFields();
        },

        resetEditFields() {
            this.posEditQuantity = null;
            this.posEditPrice = null;
            this.editingField = "";
        },

        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        registerCarrito() {
            this.$refs.SweetAlert.showConfirmSimple2("","¿Estás seguro de Registrar esta OC?","warning","Registrar") 
            .then((result) => {
                if (result.value) {
                    this.registerCar();
                }
            });
        },

        registerCar() {
            const payload = {
                datos: this.datos,
                observation: this.observation,
                money: this.money,
            };
            this.post({
                url: this.$store.getters.get__url + "/Active/storeOcAct",
                token: this.$store.getters.get__token,
                params: payload,
            })
            .then((response) => {
                if(response.statusCode == 200){
                    this.$refs.SweetAlert.showSuccess("Registro guardado Exitosamente");
                    this.$emit("registerCarrito", response.data.data);
                    this.viewfactura(response.data.note);
                    this.clearData();
                    this.mtdclosemodal();
                }else{
                    this.$refs.SweetAlert.showError("Error");
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        clearData(){
            this.datos.forEach(item => {
                item.quantity = '';        
                item.editQuantity = '';      
                item.price = '';
                item.editPrice = ''; 
                item.fAdquisicion = '';  
                item.searchBrand = null,
                item.newBrand = null,
                item.newBrandId = null,
                item.igv_num  = 0 
            });
            this.observation = '';
            this.money = {
                name: 'SOLES',
                type: 1,
                valor: 0,
                envio: 0,
            }
        },

        openPdf(id){
            window.open(
                this.$store.getters.get__url +
                "/viewpdfNotaIngreso/" + id,
                "_blank"
            );
        },

        filterKeyDni: function (e) {
            let b = false;
            b = /^\d$/.test(e.key);
            if (b == false && e.key != "Backspace") {
                e.preventDefault();
            }
        },

        validateInput(field) {
            if (this.money[field] < 0) {
                this.money[field] = 0;
            }
        },

        updateMoney() {
          if(this.money.name == 'DOLARES'){
            this.money.type = this.valorTypeVen;
          }
          else if (this.money.name == 'SOLES') {
            this.money.type = 1;
          }
        },

        validateAmountCostSend(event) {
            let sanitizedValue = event.target.value.replace(/[^0-9.]/g, '');

            const decimalCount = sanitizedValue.split('.').length - 1;
            if (decimalCount > 1) {
                sanitizedValue = sanitizedValue.slice(0, -1);
            }
            const decimalIndex = sanitizedValue.indexOf('.'); // Limitar a dos decimales
            if (decimalIndex !== -1) {
                const decimalPart = sanitizedValue.substring(decimalIndex + 1);
                sanitizedValue = `${sanitizedValue.substring(0, decimalIndex)}.${decimalPart.substring(0, 2)}`;
            }
            this.money.envio = sanitizedValue;
        },

        //Calcule
        /* mtdValor: function () {
                return this.datos.reduce((total, item) => {
                    const quantity = parseFloat(item.quantity) || 0;
                    const price = parseFloat(item.price) || 0;
                    return total + (quantity * price);
                }, 0).toFixed(3);
        }, */

        mtdValor: function () {
            if (this.datos.length > 0) {
                let valor2 = 0;
                this.datos.forEach((item) => {
                    if (item.igv_num == 0) {
                        valor2 += parseFloat(item.quantity * item.price);
                    }
                    if (item.igv_num == 1) {
                        valor2 += parseFloat(item.quantity * item.price / 1.18);
                    }
                });
                return parseFloat(valor2).toFixed(3);
            } else {
                return parseFloat(0.00).toFixed(3);
            }
        },

        /* mtdGetIgv: function () {
            const valorVenta = parseFloat(this.mtdValor()) || 0;
            const igv = valorVenta * 0.18;
            return igv.toFixed(3);
        }, */

        mtdGetIgv: function () {
            if (this.datos.length > 0) {
                let valor = 0;
                this.datos.forEach((item) => {
                    if (item.igv_num == 1) {
                        valor += parseFloat(item.quantity * item.price / 1.18);
                    }
                });
                let igv = (valor * 0.18).toFixed(3);
                return parseFloat(igv).toFixed(3);
            } else {
                return parseFloat(0.00).toFixed(3);
            }
        },

        mtdGetSubTotal: function () {
            const valorVenta = parseFloat(this.mtdValor()) || 0;
            const igv = parseFloat(this.mtdGetIgv()) || 0;
            const subtotal = valorVenta + igv;
            return subtotal.toFixed(3);
        },

        mtdGetTotal: function () {
            const subtotal = parseFloat(this.mtdGetSubTotal()) || 0;
            const envio = parseFloat(this.money.envio) || 0;
            const total = subtotal + envio;
            return total.toFixed(3);
        },

        /* mtdIgvChange: function () {
            this.datos.forEach(item => {
                if (item.igv) {
                    item.igv_num = 1;
                } else {
                    item.igv_num = 0;
                }
            });
        }, */

        mtdIgvChange: function (index) {
            const item = this.datos[index];
            item.igv_num = item.igv ? 1 : 0;
            if (item.igv_num === 1) {
                item.price = (item.price * 1.18).toFixed(3);
            } else {
                item.price = (item.price / 1.18).toFixed(3);
            }
            item.subtotal_sin_igv = (item.price * item.quantity).toFixed(3);
            this.$forceUpdate();
        },

        viewfactura: function (id) {
            window.open(
                this.$store.getters.get__url + "/ordendecompra/viewpdfAct/" + id,
                "_blank"
            );
        },

        //Modal Marca
        mtdopenmodal: function (item, index) {
            if (item.searchBrand.length > 2) {
                this.$emit("openModalBrand", item, index);
            } else {
                this.$refs.SweetAlert.showWarning('Digite Marca. Max 3 Caracteres');
            }
        },

        addBrandCarrito: function (payload, pos) {
            this.datos[pos].newBrand = payload.brand; 
            this.datos[pos].newBrandId = payload.id;
        },

        //Agregar Marca en caso no dese escojer ninguna
        mtdAddBrand: function(id) {
            this.$emit("mtdAddBrand", id);
        }

       
    },
};
</script>
<style scoped>
.observation {
    width: 300px;
}
@media (max-width: 992px) {
   
    .responsive-footer {
        flex-direction: column;
    }

    .responsive-footer-div {
        justify-content: end;
    }
}

@media (max-width: 365px) {
    .responsive-footer>.text-white {
        flex-direction: column;
        padding: 0px 20px 0px 20px;
    }

    .responsive-footer>.text-white>div {
        margin: 0px 0px 9px 0px !important;
    }
}

.btn-register {
    background-color: #900052; 
    border: 2px solid #900052; 
}

.btn-register:hover {
    background-color: #700042;
    border-color: #700042; 
}

.bg-light-green {
    background-color: #ddf9f0;
}
.custom-width {
    width: 100px;
}
</style>

